import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  height: '75vh',
  position: 'relative',
  color: theme.palette.text.primary,
  '& .HSBGContainer': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },
  '& .HSBGGradient': {
    background: `linear-gradient(
        180deg,
        ${alpha(theme.palette.background.primary, 0.3)} 0%,
        ${alpha(theme.palette.background.primary, 0.5)} 50%,
        ${theme.palette.background.primary} 100%
      )
    `,
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 2,
  },
  '& .HSBGPattern': {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '30%',
    zIndex: 1,
    maskImage: `linear-gradient(
      to bottom,
      transparent 0%,
      ${alpha(theme.palette.background.primary, 0.5)} 50%,
      ${theme.palette.background.primary} 100%
    )`,
    filter: 'blur(0.5px)',
  },

  '& .HSContentContainer': {
    position: 'absolute',
    bottom: '0',
    left: 0,
    right: 0,
    zIndex: 3,
    width: '100%',
    padding: theme.spacing(9, 2, 6),
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(3, 2),
    },
    '& .HSText': {
      fontWeight: 500,
      textAlign: 'center',
      maxWidth: theme.typography.pxToRem(738),
      margin: '0 auto',
      color: theme.palette.text.secondary,
    },
    '& .HSWidgetContainer': {
      width: 'max(70% , 1000px)',
      margin: 'auto',
      marginTop: theme.spacing(4),
      [theme.breakpoints.down('lg')]: {
        width: 'max(90% , 600px)',
      },
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  },
  '& .HSFixedButton': {
    position: 'fixed',
    bottom: '0',
    left: '0',
    width: '100%',
    zIndex: 99,
    borderRadius: 0,
    height: theme.spacing(6.25),
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(15),
    textTransform: 'uppercase',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default StyledBox;
